module.exports = __webpack_public_path__ + "./images/4.0354005082c4e1eb36286e082673e370.png";